import NoResultPage from "./NoResultPage";
export default NoResultPage;